import { fmtKwp, fmtMoney, ZONE_LABEL } from "@/lib/apolloCalc";

// Invio email della simulazione a sales@pixasolar.online tramite FormSubmit.co (nessun backend necessario).
// Nota: al primo invio FormSubmit manda a sales@pixasolar.online un'email di attivazione da confermare.
const FORMSUBMIT_URL = "https://formsubmit.co/ajax/sales@pixasolar.online";

export async function sendSimulationEmail(result, contact = null) {
  try {
    return await postToFormSubmit(result, contact);
  } catch (err) {
    // Messaggi sempre in italiano per il visitatore
    const msg = String(err?.message || "");
    if (/activat/i.test(msg)) throw new Error("servizio email in attivazione");
    if (err instanceof TypeError || /fetch|network/i.test(msg)) throw new Error("problema di connessione");
    throw new Error("servizio email non disponibile");
  }
}

async function postToFormSubmit(result, contact) {
  const fields = {
    _subject: contact ? "Nuova richiesta preventivo Apollo.AI" : "Nuova simulazione Apollo.AI",
    _captcha: "false",
    _template: "table",
    "Via / Indirizzo": result.formattedAddress || result.address,
    "Città": result.city || "non riconosciuta",
    "Tipologia stabile": result.buildingType,
    "Consumo annuale stimato": result.consumptionEstimated ? "non indicato" : `${result.consumptionUsed} kWh`,
    "Numero pannelli calcolati": result.panels,
    "Potenza kWp calcolata": `${fmtKwp(result.kwp)} kWp`,
    "Percentuale di fattibilità": `${result.feasibility}%`,
    "Risparmio stimato": `${fmtMoney(result.savings, result.currency)}/anno`,
    Zona: ZONE_LABEL[result.zone],
    Coordinate: result.lat != null ? `${result.lat}, ${result.lng}` : "n.d.",
  };
  if (contact) Object.assign(fields, { Nome: contact.name, Telefono: contact.phone, Email: contact.email || "", Note: contact.notes || "" });
  const res = await fetch(FORMSUBMIT_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(fields),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || String(data.success) !== "true") throw new Error(data.message || "Invio non riuscito");
  return data;
}
